import React from 'react';

export const PlainTableContainer = (props: React.HTMLAttributes<HTMLDivElement>) => <div {...props} />;
